module.exports = __webpack_public_path__ + "static/media/Guitar.512ad421.wav";